import React, { useEffect, useCallback, useState } from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import * as api from '../../api'
import { Loader } from '../../ui'
import Error from '../Error'
import Fine from '../Fine'
import BulletinForm from '../BulletinForm'
import useApi from 'commons/js/hooks/useApi'
import Routes from 'commons/js/routes/routes'
import { useLocation, useHistory, withRouter } from 'react-router-dom'

const Portal = ({ town, onChangeTown, bulletinNumber: bulletinNumberParams, getFine, brandId }) => {
    const {
        response: { result: fine, error },
        loading,
        sendRequest: requestGetFine,
        resetResponse: resetFine,
    } = useApi(getFine)

    const [ bulletinNumber, setBulletinNumber ] = useState(bulletinNumberParams)
    const [ townId, setTownId ] = useState(town)

    const history = useHistory()
    const search = useLocation().search || null
    const bulletinNumberUrl = search && (new URLSearchParams(search).get('bulletinNumber'))

    useEffect(() => {
        bulletinNumberUrl && setBulletinNumber(bulletinNumberUrl)
    }, [bulletinNumberUrl, setBulletinNumber])

    useEffect(() => {
        bulletinNumber && requestGetFine({ townId, bulletinNumber, brandId })
    }, [requestGetFine, townId, bulletinNumber, brandId])

    function onBack () {
        setBulletinNumber(null)
        resetFine()
        history.push(Routes.finePortalWithFinePath({townId, brandId}))
    }

    const onSearch = useCallback(
        (bulletinNumber, townId) => {
            setBulletinNumber(bulletinNumber)
            setTownId(townId)
            onChangeTown(townId)
            history.push(Routes.finePortalWithFinePath({townId, bulletinNumber, brandId}))
        }, [brandId, history, onChangeTown]
    )

    useEffect(() => {
        bulletinNumber && onSearch(bulletinNumber, townId)
    }, [ onSearch, townId, bulletinNumber ])

    if (loading) {
        return (
            <Loader>
                <FormattedMessage defaultMessage='Buscando ...' />
            </Loader>
        )
    }

    if (error) {
        return (
            <Error
              error={error}
              onBack={onBack}
            />
        )
    }

    if (fine) {
        return (
            <Fine
              fine={fine}
              town={{ id: townId }}
              onBack={onBack}
              brandId={brandId}
              requestGetFine={requestGetFine}
            />
        )
    }

    return (
        <BulletinForm brandId={brandId} townId={townId} onSearch={onSearch} />
    )
}

Portal.propTypes = {
    getFine: PropTypes.func.isRequired,
    town: PropTypes.number,
    brandId: PropTypes.number,
    bulletinNumber: PropTypes.number,
    onChangeTown: PropTypes.func,
}

Portal.defaultProps = {
    onChangeTown: () => {},
    bulletinNumber: null,
    brandId: null,
    getFine: api.getFine,
    match: {
        params: {},
    },
}

export default withRouter(Portal)
